import React, { useEffect } from 'react';

import { WorkflowEntity } from '../../workflow/Workflow.interface';
import { useFindWorkflowVersionByEntity } from '../../workflow/Workflow.hooks';
import WorkflowStatusSelector, {
  WorkflowStatusSelectorProps
} from '../../workflow/components/WorkflowStatusSelector';

export type ChangeOrderStatusFilterProps = Pick<
  WorkflowStatusSelectorProps,
  'value' | 'onChange'
>;

const ChangeOrderStatusFilter: React.FC<ChangeOrderStatusFilterProps> = (
  props: ChangeOrderStatusFilterProps
) => {
  const { workflowVersion, isLoading, loadingError, findWorkflowVersion } =
    useFindWorkflowVersionByEntity(WorkflowEntity.ChangeOrder);

  useEffect(() => {
    findWorkflowVersion();
  }, [findWorkflowVersion]);

  return (
    <WorkflowStatusSelector
      {...props}
      error={loadingError}
      isLoading={isLoading}
      workflowVersion={workflowVersion}
      textFieldProps={{ label: undefined, placeholder: 'Select Status' }}
    />
  );
};

export default ChangeOrderStatusFilter;
